export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Terre des Hommes - Annual Report 2017",
    "shortTitle": "",
    "description": "",
    "width": 1365,
    "height": 1024,
    "currentLanguage": "EN",
    "languages": [],
    "basePath": "/making-children-heard",
    // "basePath": "",
    "companyLogo": "1-logo.png",
    "publishURL": "https://s3-eu-west-1.amazonaws.com/touchline/terre-des-hommes/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": false,
      "mobileSwitch": false
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `  
        <img id="1-title" class="halfScale" src="/making-children-heard/static/_content/1-title.png" style="top: 480px; left: 220px;"/>
        <img id="1-sub" class="halfScale" src="/making-children-heard/static/_content/1-sub.png" style="top: 830px; left: 487px;"/>
        <img id="1-arrow" class="halfScale pointer" src="/making-children-heard/static/_content/1-arrow.png" onclick="Publish.nextPage()" style="top: 866px; left: 1252px;"/>
        <img id="1-logo" class="halfScale" src="/making-children-heard/static/_content/1-logo.png" style="top: 71px; left: 835px;"/>
        `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.fromTo(idOf("1-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)
          .fromTo(idOf("1-sub"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, "-=0.4")
          .fromTo(idOf("1-logo"), 0.8, {opacity:0, x:30}, {opacity:1, x:0}, "-=0.4")
          .fromTo(idOf("1-arrow"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, onComplete: function() {
            pg1Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});
            pg1Bounce.to(idOf("1-arrow"), 0.6, {x:-20, delay:0.8})
            .to(idOf("1-arrow"), 1, {x:0, ease:Bounce.easeOut}, "-=0")
          }}, "-=0.4")
        }
        

        function onPageLeave() {
          pg1Anim.stop();
          pg1Bounce.stop();
        }
      `,
      "searchText": "MAKING CHILDREN HEARD ACROSS THE GLOBE  ANNUAL REPORT 2017 ©TDH/Matthew O'Brien  Use your arrow keys or mouse, or swipe to navigate through the publication"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 2-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 2-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img id="2-title" class="halfScale" src="/making-children-heard/static/_content/2-title.png" style="top: 340px; left: 667px;"/>
      <img id="2-cont" class="halfScale pointer" src="/making-children-heard/static/_content/2-cont.png" onclick="showOverlay('pg2-pop')" style="top: 861px; left: 948px;"/>
      <img class="halfScale 2-img" src="/making-children-heard/static/_content/2-img.jpg" style="top: 429px; left: 142px;"/>
      <img class="halfScale 2-img" src="/making-children-heard/static/_content/2-text.png" style="top: 680px; left: 144px;"/>

      <div class="addContentLink" style="top:799px;left:593px;width:188px;height:21px">
        <a href="http://www.childrenonthemove.org/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:829px;left:363px;width:308px;height:23px">
        <a href="http://www.childrenonthemove.org/" target="_blank"></a>
      </div>

      <div id="pg2-pop" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg2-pop.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg2-pop')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
        <div class="contentLink" style="top:430px;left:413px;width:224px;height:21px">
          <a href="https://destination-unknown.org/" target="_blank"></a>
        </div>
        <div class="contentLink" style="top:643px;left:583px;width:127px;height:23px">
          <a href="http://www.time-to-talk.info/en/home/" target="_blank"></a>
        </div>
        <div class="contentLink" style="top:459px;left:846px;width:132px;height:23px">
          <a href="https://www.childrenwin.org/" target="_blank"></a>
        </div>
      </div>

      `,
      "script": `
      function onPageEnter() {
        pg2Anim = new TimelineMax();
        pg2Anim.fromTo(idOf("2-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)
        .staggerFromTo(cOf("2-img"), 0.8, {opacity:0, x:30}, {opacity:1, x:0}, 0.4, "-=0.4")
        .fromTo(idOf("2-cont"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(cOf("2-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: addContentLinks}, "-=0.4")
      }

      function onPageLeave() {
        pg2Anim.stop();
        removeContentLinks();
        hideOverlay('pg2-pop');
      }
      `,
      "searchText": "02/14  TERRE DES HOMMES  FOREWORD  FOREWORD  BACK  ©TDH  Lysiane André is Chair of the Terre des Hommes International Board  Terre des Hommes works to make positive change happen for vulnerable and disadvantaged children by defending their rights and helping them reach their full potential across the globe. In 2017, we took yet more steps towards achieving this. We united with six other organisations who specialise in child rights to end violence against children, and encourage governments worldwide to renew their commitment to respect the rights of every child. As co-chair of the Initiative for Child Rights in the Global Compacts, Terre des Hommes was crucial in organising the Global Conference for Children on the  Move. This conference showed our commitment to putting children at the heart of two UN agreements on how governments can best manage migration and care for refugees.  Click to continue reading  NEXT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 3-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 3-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>
      
      <img id="3-title" class="halfScale" src="/making-children-heard/static/_content/3-title.png" style="top: 340px; left: 667px;"/>
      <img id="3-cont" class="halfScale pointer" src="/making-children-heard/static/_content/3-cont.png" onclick="showOverlay('pg3-pop')" style="top: 861px; left: 948px;"/>
      <img class="halfScale 3-img" src="/making-children-heard/static/_content/3-img.jpg" style="top: 430px; left: 142px;"/>
      <img class="halfScale 3-img" src="/making-children-heard/static/_content/3-text.png" style="top: 683px; left: 144px;"/>

      <div id="pg3-pop" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg3-pop.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg3-pop')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg3Anim = new TimelineMax();
        pg3Anim.fromTo(idOf("3-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)
        .staggerFromTo(cOf("3-img"), 0.8, {opacity:0, x:30}, {opacity:1, x:0}, 0.4, "-=0.4")
        .fromTo(idOf("3-cont"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(cOf("3-arrow"), 0.8, {opacity:0}, {opacity:1}, "-=0.4")
      }
      

      function onPageLeave() {
        pg3Anim.stop();
        hideOverlay('pg3-pop');
      }
      `,
      "searchText": "03/14  TERRE DES HOMMES  FOREWORD  FOREWORD  BACK  ©TDH  Delphine Moralis is Secretary General of the Terre des Hommes International Federation  Terre des Hommes stands with children and young people to demand and facilitate change. From innovating primary health care for children in rural areas in West Africa, to educational activities in Lebanon for Syrian refugee children. From listening to working children about their fear of verbal, physical and sexual abuse, to working with the industry to achieve supply chains free of exploitative child labour. Our work in 2017 has been true to our mission, to protect children, their rights, and equitable development. But as we move forward at a fast pace towards 2030, many commitments within  the Sustainable Development Goals concerning children are still far from reality. Still today, 357 million children live in zones affected by conflict, 73 million children work in hazardous or dangerous conditions, 10 million children are enslaved, and at least as many children live in forced displacement. This is no time to be complacent.  Click to continue reading  NEXT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 4-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 4-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img id="4-title" class="halfScale" src="/making-children-heard/static/_content/4-title.png" style="top: 461px; left: 471px;"/>
      <img class="halfScale 4-img" src="/making-children-heard/static/_content/4-img.jpg" style="top: 100px; left: 425px;"/>

      <img class="halfScaleC 4-ctr" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg4-pop-1')" style="top: 636px; left: 125px;"/>
      <img class="halfScaleC 4-ctr" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg4-pop-2')" style="top: 792px; left: 125px;"/>

      <div id="pg4-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg4-pop1.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg4-pop-1')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
        <div class="contentLink" style="top:612px;left:373px;width:191px;height:23px">
          <a href="https://accountablenow.org/" target="_blank"></a>
        </div>
        <div class="contentLink" style="top:369px;left:848px;width:247px;height:23px">
          <a href="https://www.keepingchildrensafe.org.uk/" target="_blank"></a>
        </div>
        <div class="contentLink" style="top:583px;left:771px;width:428px;height:23px">
          <a href="mailto:childsafeguarding@terredeshommes.org" target="_blank"></a>
        </div>
      </div>

      <div id="pg4-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg4-pop-2.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg4-pop-2')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg4Anim = new TimelineMax();
        pg4Anim.fromTo(idOf("4-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)
        .staggerFromTo(cOf("4-ctr"), 0.8, {opacity:0}, {opacity:1}, 0.4, "-=0.4")
        .fromTo(cOf("4-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          cOf("4-ctr")[0].className += " pointer pulse animatedpulse";
          cOf("4-ctr")[1].className += " pointer pulse animatedpulse";
        }}, "-=0.4")
      }

      function onPageLeave() {
        pg4Anim.stop();
        cOf("4-ctr")[0].className = "halfScaleC 4-ctr";
        cOf("4-ctr")[1].className = "halfScaleC 4-ctr";
        hideOverlay('pg4-pop-1');
        hideOverlay('pg4-pop-2');
      }
      `,
      "searchText": "04/14  TERRE DES HOMMES  ABOUT  ©TDH / Andrea Frazzetta  ABOUT TERRE DES HOMMES  BACK  Click to read ‘Safeguarding and accountability’  Click to read ‘Who we are’  Founded in 1966, the Terre des Hommes International Federation strives to empower children to shape the future they want to live in, and to guarantee their rights are respected in their entirety. We work to make this vision a reality by supporting children anywhere where decisions are made or actions are taken which affect them. From helping them in the communities they live in to voicing their concerns to the world leaders, governments and international institutions who  can improve their situations, Terre des Hommes places children at the heart of any debate affecting them. Terre des Hommes has helped millions of children since our movement was first founded. We have provided children with healthcare, humanitarian assistance and an improved quality of life. We have protected them from exploitation, violence and abuse. And we have empowered children to become the masters of their own future.  NEXT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 5-1-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 5-1-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScale 5-1-title" src="/making-children-heard/static/_content/5-title.png" style="top: 258px; left: 523px;"/>
      <img class="halfScale 5-1-title" src="/making-children-heard/static/_content/5-sub.png" style="top: 394px; left: 389px;"/>

      <img id="5-img" class="halfScale" src="/making-children-heard/static/_content/5-img-1.jpg" style="top: 601px; left: 364px;"/>
      <img id="5-read" class="halfScale pointer" src="/making-children-heard/static/_content/read-more.png" onclick="Publish.nextSection()" style="top: 515px; left: 747px;"/>
      `,
      "script": `
      function onPageEnter() {
        pg5Anim = new TimelineMax();
        pg5Anim.staggerFromTo(cOf("5-1-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .fromTo(idOf("5-img"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, "-=0.6")
        .fromTo(idOf("5-read"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(cOf("5-1-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          pg5Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});
          pg5Bounce.to(idOf("5-read"), 0.6, {y:-20, delay:0.8})
          .to(idOf("5-read"), 1, {y:0, ease:Bounce.easeOut}, "-=0")
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg5Anim.stop();
        pg5Bounce.stop();
      }
      `,
      "searchText": "05/14  TERRE DES HOMMES  CHILDREN IN MIGRATION  PROTECTING CHILDREN ON THE MOVE From fleeing conflict or disaster to seeking a better life or reuniting with their families, children are on the move across the globe. Here are just some of the ways Terre des Hommes is providing them with protection, security and hope BACK  NEXT  READ MORE  ©TDH – Iraq"
    },{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5-2.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 5-2-title" src="/making-children-heard/static/_content/5-iraq.png" style="top: 180px; left: 763px;"/>
      <img class="halfScale 5-2-title" src="/making-children-heard/static/_content/5-sub2.png" style="top: 232px; left: 383px;"/>
      <img class="halfScale 5-2-title" src="/making-children-heard/static/_content/5-bangladesh.png" style="top: 548px; left: 711px;"/>
      <img id="5-img-2" class="halfScale" src="/making-children-heard/static/_content/5-img-2.jpg" style="top: 619px; left: 809px;"/>

      <img class="halfScaleC 5-btn-2" src="/making-children-heard/static/_content/btn-play.png" onclick="Publish.openVideo('https://www.youtube.com/embed/_nYcQ8B4Il4')" style="top: 212px; left: 125px;"/>
      <img class="halfScaleC 5-btn-2" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg5-pop-1')" style="top: 587px; left: 125px;"/>
      <img class="halfScaleC 5-btn-2" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg5-pop-2')" style="top: 742px; left: 125px;"/>

      <img class="halfScaleC 5-btn-2" src="/making-children-heard/static/_content/btn-down.jpg" onclick="Publish.nextSection()" style="top: 823px; left: 668px;"/>

      <div id="pg5-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg5-pop1.jpg">
        <div class="abs pointer" onclick="Publish.openVideo('https://player.vimeo.com/video/241848396?autoplay=1&color=ff9933&title=0&byline=0')" style="top:354px;left:949px;width:95px;height:95px;"></div>
        <div class="abs pointer" onclick="hideOverlay('pg5-pop-1')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>

      <div id="pg5-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg5-pop2.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg5-pop-2')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg5sec2Anim = new TimelineMax();
        pg5sec2Anim.staggerFromTo(cOf("5-2-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.6, 0.8)
        .fromTo(idOf("5-img-2"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, "-=0.6")
        .staggerFromTo(cOf("5-btn-2"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          cOf("5-btn-2")[0].className += " pointer pulse animatedpulse";
          cOf("5-btn-2")[1].className += " pointer pulse animatedpulse";
          cOf("5-btn-2")[2].className += " pointer pulse animatedpulse";
          cOf("5-btn-2")[3].className += " pointer pulse animatedpulse";
        }}, 0.4, "-=0.4")
      }
      

      function onPageLeave() {
        pg5sec2Anim.stop();
        cOf("5-btn-2")[0].className = "halfScaleC 5-btn-2";
        cOf("5-btn-2")[1].className = "halfScaleC 5-btn-2";
        cOf("5-btn-2")[2].className = "halfScaleC 5-btn-2";
        cOf("5-btn-2")[3].className = "halfScaleC 5-btn-2";
        hideOverlay('pg5-pop-1');
        hideOverlay('pg5-pop-2');
      }
      `,
      "searchText": "05/14  CHILDREN IN MIGRATION  IRAQ  Click to view Watch Ahmed's story here  “Since he started the treatment, Ahmed improved dramatically… Now he goes to the Child Friendly Space and says who he wants to play with” – Ahmed’s mother In protracted crisis, it is the most vulnerable children who suffer the most. Terre des Hommes (Italy) is working with disabled children in northern Iraq by promoting community-based rehabilitation, raising awareness about disability within  communities and training teachers how to teach children with special needs. The programme helped 250 children with disabilities in 2017, and also provided psychological support to them and their families.  BANGLADESH  Click to read how TDH is helping refugees in Greece  Click to read how we are providing healthcare in Myanmar  In 2017, over 600,000 Rohingya refugees were forced to escape a renewed wave of violence in Rakhine, Myanmar. In Bangladesh, Terre des Hommes (Lausanne) provided four-year-old Maya (pictured right) and over 2,000 other refugees with treatment for malnutrition. 900 children also received psychological and social support.  ©TDH"
    },{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5-3.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 5-3-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 5-3-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScale 5-3-title" src="/making-children-heard/static/_content/5-lebanon.png" style="top: 183px; left: 736px;"/>
      <img class="halfScale 5-3-title" src="/making-children-heard/static/_content/5-sub3.png" style="top: 231px; left: 421px;"/>

      <img id="5-img-3" class="halfScale" src="/making-children-heard/static/_content/5-img-3.jpg" style="top: 449px; left: 364px;"/>

      <img class="halfScaleC 5-btn-3" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg5-pop-3')" style="top: 583px; left: 125px;"/>
      <img class="halfScaleC 5-btn-3" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg5-pop-4')" style="top: 767px; left: 125px;"/>

      <div id="pg5-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg5-pop3.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg5-pop-3')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>

      <div id="pg5-pop-4" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg5-pop4.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg5-pop-4')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg5sec3Anim = new TimelineMax();
        pg5sec3Anim.staggerFromTo(cOf("5-3-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .fromTo(idOf("5-img-3"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, "-=0.6")
        .staggerFromTo(cOf("5-btn-3"), 0.8, {opacity:0}, {opacity:1}, 0.4, "-=0.4") 
        .fromTo(cOf("5-3-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          cOf("5-btn-3")[0].className += " pointer pulse animatedpulse";
          cOf("5-btn-3")[1].className += " pointer pulse animatedpulse";
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg5sec3Anim.stop();
        cOf("5-btn-3")[0].className = "halfScaleC 5-btn-3";
        cOf("5-btn-3")[1].className = "halfScaleC 5-btn-3";
        hideOverlay('pg5-pop-3');
        hideOverlay('pg5-pop-4');

      }
      `,
      "searchText": "05/14  CHILDREN IN MIGRATION  LEBANON “I feel so relieved now that we have left Syria and the war behind” – Sayid, 10 Over 7,000 refugee children from Syria enrolled in educational activities in Lebanon in 2017 thanks to the Back to the Future programme – run by Terre des Hommes (Italy) and Terre des Hommes (Netherlands).  The programme helps children like ten-year-old Sayid, who is now learning basic literacy and numeracy skills after escaping the war which killed his sister in an airstrike. © Andy Hall  BACK  NEXT  Click to read about our Kenya project  Click to read about our West Africa project"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 6-1-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 6-1-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScale 6-1-title" src="/making-children-heard/static/_content/6-title.png" style="top: 234px; left: 521px;"/>
      <img class="halfScale 6-1-title" src="/making-children-heard/static/_content/6-sub.png" style="top: 372px; left: 380px;"/>

      <img id="6-img-1" class="halfScale" src="/making-children-heard/static/_content/6-img-1.jpg" style="top: 579px; left: 365px;"/>

      <img id="6-read" class="halfScale pointer" src="/making-children-heard/static/_content/read-more.png" onclick="Publish.nextSection()" style="top: 492px; left: 748px;"/>
      `,
      "script": `
      function onPageEnter() {
        pg6Anim = new TimelineMax();
        pg6Anim.staggerFromTo(cOf("6-1-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .fromTo(idOf("6-img-1"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, "-=0.6")
        .fromTo(idOf("6-read"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(cOf("6-1-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          pg6Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});
          pg6Bounce.to(idOf("6-read"), 0.6, {y:-20, delay:0.8})
          .to(idOf("6-read"), 1, {y:0, ease:Bounce.easeOut}, "-=0")
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg6Anim.stop();
        pg6Bounce.stop();
      }
      `,
      "searchText": "06/14  TERRE DES HOMMES  CHILD LABOUR  IMPROVING THE LIVES OF WORKING CHILDREN 152 million children across the globe are trapped in exploitative child labour, with 73 million working in hazardous conditions. Terre des Hommes works with the children affected, their families and communities to give them a childhood again BACK  READ MORE  NEXT  ©TDH"
    },{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6-2.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 6-2-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 6-2-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScale 6-2-title" src="/making-children-heard/static/_content/6-global.png" style="top: 183px; left: 746px;"/>
      <img class="halfScale 6-2-title" src="/making-children-heard/static/_content/6-sub2.png" style="top: 231px; left: 460px;"/>

      <img class="halfScaleC 6-btn-2" src="/making-children-heard/static/_content/btn-play.png" onclick="Publish.openVideo('https://www.youtube.com/embed/xHwzBOtTadw')" style="top: 509px; left: 125px;"/>
      <img class="halfScaleC 6-btn-2" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg6-pop-1')" style="top: 737px; left: 125px;"/>

      <div class="addContentLink" style="top:460px;left:701px;width:79px;height:21px">
        <a href="https://www.terredeshommes.org/child-labourers-flag-abuse-and-sexual-violence-as-biggest-fears-in-ground-breaking-tdh-survey/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:491px;left:362px;width:49px;height:21px">
        <a href="https://www.terredeshommes.org/child-labourers-flag-abuse-and-sexual-violence-as-biggest-fears-in-ground-breaking-tdh-survey/" target="_blank"></a>
      </div>

      <div class="addContentLink" style="top:369px;left:1084px;width:141px;height:21px">
        <a href="http://childlabour2017.org/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:400px;left:807px;width:419px;height:21px">
        <a href="http://childlabour2017.org/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:430px;left:807px;width:155px;height:21px">
        <a href="http://childlabour2017.org/" target="_blank"></a>
      </div>

      <div id="pg6-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg6-pop1.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg6-pop-1')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
        <div class="contentLink" style="top:400px;left:374px;width:292px;height:23px">
          <a href="http://www.responsible-mica-initiative.com/" target="_blank"></a>
        </div>
      </div>
      
      `,
      "script": `
      function onPageEnter() {
        pg6sec2Anim = new TimelineMax();
        pg6sec2Anim.staggerFromTo(cOf("6-2-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .staggerFromTo(cOf("6-btn-2"), 0.8, {opacity:0}, {opacity:1}, 0.4, "-=0.4")
        .fromTo(cOf("6-2-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          addContentLinks();
          cOf("6-btn-2")[0].className += " pointer pulse animatedpulse";
          cOf("6-btn-2")[1].className += " pointer pulse animatedpulse";
        }}, "-=0.4")
      }

      function onPageLeave() {
        pg6sec2Anim.stop();
        removeContentLinks();
        cOf("6-btn-2")[0].className = "halfScaleC 6-btn-2";
        cOf("6-btn-2")[1].className = "halfScaleC 6-btn-2";
        hideOverlay('pg6-pop-1');
      }
      `,
      "searchText": "06/14  CHILD LABOUR  GLOBAL “I’m proud to help my family, but the work is tiring – especially lifting the heavy oven plate. I have burned myself many times” – Ana, 10  BACK  Click to view What do working children think about their jobs?  Click to read how TDH is helping children working in mica mines  The most important voices when discussing child labour are children themselves. Terre des Hommes (Germany), together with Save the Children, Kindernothilfe and other child rights groups, undertook the Time to Talk survey in 2017. The survey interviewed around 1,800 working children in 36 countries across the globe about their experiences, and will use their testimony to find lasting solutions to the problem of exploitative child labour.  Terre des Hommes launched the results of the Time to Talk survey at the Fourth Global Conference on the Sustained Eradication of Child Labour in Buenos Aires, Argentina. The survey received international media coverage and was also presented directly to officials at the event. The report highlighted how children’s biggest work-related fears are physical, verbal and sexual abuse. However, they appreciated being able to support their families and earn enough money to afford an education.  NEXT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 7-1-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 7-1-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScale 7-1-title" src="/making-children-heard/static/_content/7-title.png" style="top: 591px; left: 526px;"/>
      <img class="halfScale 7-1-title" src="/making-children-heard/static/_content/7-sub.png" style="top: 739px; left: 368px;"/>

      <img id="7-img-1" class="halfScale" src="/making-children-heard/static/_content/7-img-1.jpg" style="top: 124px; left: 366px;"/>
      <img id="7-read" class="halfScale pointer" src="/making-children-heard/static/_content/read-more.png" onclick="Publish.nextSection()" style="top: 860px; left:748px;"/>
      `,
      "script": `
      function onPageEnter() {
        pg7Anim = new TimelineMax();
        pg7Anim.staggerFromTo(cOf("7-1-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.6, 0.8)
        .fromTo(idOf("7-img-1"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(idOf("7-read"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(cOf("7-1-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          pg7Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});
          pg7Bounce.to(idOf("7-read"), 0.7, {y:-20, delay:0.8})
          .to(idOf("7-read"), 1, {y:0, ease:Bounce.easeOut}, "-=0")
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg7Anim.stop();
        pg7Bounce.stop();
      }
      `,
      "searchText": "07/14  TERRE DES HOMMES  CHILD SEXUAL EXPLOITATION  ©TDH  BACK  STOPPING CHILD SEXUAL EXPLOITATION Over one million children are trapped in the sex industry worldwide, with many girls being a virgin when they receive their first customer, and children infected with HIV within months. Terre des Hommes is committed to fighting for a brighter, better future for them READ MORE  NEXT"
    },{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7-2.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 7-2-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 7-2-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScale 7-2-title" src="/making-children-heard/static/_content/7-netherlands.png" style="top: 245px; left: 704px;"/>
      <img class="halfScale 7-2-title" src="/making-children-heard/static/_content/7-sub2.png" style="top: 285px; left: 393px;"/>

      <img class="halfScale 7-2-img" src="/making-children-heard/static/_content/7-img-2.jpg" style="top: 374px; left: 809px;"/>
      <img class="halfScaleC 7-2-btn" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg7-pop-1')" style="top: 521px; left:125px;"/>
      
      <div class="addContentLink" style="top:369px;left:364px;width:196px;height:21px">
        <a href="https://watchnederland.nl/" target="_blank"></a>
      </div>

      <div id="pg7-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg7-pop1.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg7-pop-1')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
        <div class="contentLink" style="top:705px;left:496px;width:95px;height:23px">
          <a href="https://www.netflix.com/be-en/title/80182553" target="_blank"></a>
        </div>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg7sec2Anim = new TimelineMax();
        pg7sec2Anim.staggerFromTo(cOf("7-2-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .fromTo(cOf("7-2-img"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(cOf("7-2-btn"), 0.8, {opacity:0}, {opacity:1}, "-=0.4")
        .fromTo(cOf("7-2-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          addContentLinks();
          cOf("7-2-btn")[0].className += " pointer pulse animatedpulse";
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg7sec2Anim.stop();
        removeContentLinks();
        cOf("7-2-btn")[0].className = "halfScaleC 7-2-btn";
        hideOverlay('pg7-pop-1');
      }
      `,
      "searchText": "07/14 TERRE DES HOMMES  CHILD SEXUAL EXPLOITATION  NETHERLANDS “When I was abused by pimps, I sometimes begged customers for help. But the customers always get away with it – and they always pay the pimps” – Anonymous  BACK  Click to read how TDH is tackling online child sexual exploitation  WATCH Nederland, a hotline set up by Terre des Hommes (Netherlands) and other organisations in 2017, allows members of the public to report suspicions of child trafficking and sexual exploitation. The hotline has received 131 reports, 53 of which were assessed as being substantial enough to hand over to the Dutch police, with WATCH also using fake online profiles as bait to catch and monitor traffickers, pimps and their customers.  NEXT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 8-1-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 8-1-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScale 8-1-title" src="/making-children-heard/static/_content/8-title.png" style="top: 264px; left: 443px;"/>
      <img class="halfScale 8-1-title" src="/making-children-heard/static/_content/8-sub.png" style="top: 401px; left: 367px;"/>

      <img class="halfScale 8-1-img" src="/making-children-heard/static/_content/8-img-1.jpg" style="top: 618px; left: 366px;"/>
      <img id="8-read" class="halfScale pointer" src="/making-children-heard/static/_content/read-more.png" onclick="Publish.nextSection()" style="top: 529px; left:747px;"/>
      `,
      "script": `
      function onPageEnter() {
        pg8Anim = new TimelineMax();
        pg8Anim.staggerFromTo(cOf("8-1-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.6, 0.8)
        .fromTo(cOf("8-1-img"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(idOf("8-read"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(cOf("8-1-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          pg8Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});
          pg8Bounce.to(idOf("8-read"), 0.8, {y:-20, delay:0.8})
          .to(idOf("8-read"), 1, {y:0, ease:Bounce.easeOut}, "-=0")
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg8Anim.stop();
        pg8Bounce.stop();
      }
      `,
      "searchText": "08/14  TERRE DES HOMMES  SUSTAINABLE DEVELOPMENT  ACHIEVING THE SUSTAINABLE DEVELOPMENT GOALS Children and youth are the main participants in their own development and must play a crucial role in achieving the Sustainable Development Goals (SDGs). Terre des Hommes is working to put their needs at the heart of the implementation of the SDGs BACK  NEXT READ MORE  ©Mundubat/TDH France  READ MORE"
    },{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8-2.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 8-2-title" src="/making-children-heard/static/_content/8-columbia.png" style="top: 245px; left: 731px;"/>
      <img class="halfScale 8-2-title" src="/making-children-heard/static/_content/8-sub2.png" style="top: 290px; left: 438px;"/>

      <img class="halfScale 8-2-img" src="/making-children-heard/static/_content/8-img-2.jpg" style="top: 432px; left: 809px;"/>
      <img class="halfScaleC 8-2-btn" src="/making-children-heard/static/_content/btn-down.jpg" onclick="Publish.nextSection()" style="top: 792px; left: 726px;"/>

      <div class="addContentLink" style="top:290px;left:612px;width:145px;height:21px">
        <a href="http://tallerabierto.org/" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg8sec2Anim = new TimelineMax();
        pg8sec2Anim.staggerFromTo(cOf("8-2-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .fromTo(cOf("8-2-img"), 0.8, {opacity:0, x:30}, {opacity:1, x:0}, "-=0.4")
        .fromTo(cOf("8-2-btn"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          addContentLinks();
          cOf("8-2-btn")[0].className += " pointer pulse animatedpulse";
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg8sec2Anim.stop();
        removeContentLinks();
        cOf("8-2-btn")[0].className = "halfScaleC 8-2-btn";
      }
      `,
      "searchText": "08/14  SUSTAINABLE DEVELOPMENT  COLOMBIA “Thanks to Taller Abierto and Terre des Hommes, we get to learn about how armed groups recognise and recruit vulnerable children, and have established our own strategy to ensure no other children are recruited” – Anonymous teenager in Buenaventura Despite the historic peace deal agreed between the Colombian government and Farc rebels, children and young people are still having their rights violated on a daily basis in the city of Buenaventura. A joint report by Terre des Hommes (France) and Terre des Hommes (Switzerland) shone a light on how children are blocked from attending school by armed groups, who charge a tax to travel in between districts. The report also highlighted how girls face a higher risk of sexual abuse if they live in territories controlled by these groups."
    },{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8-3.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 8-3-title" src="/making-children-heard/static/_content/8-sudan.png" style="top: 245px; left: 708px;"/>
      <img class="halfScale 8-3-title" src="/making-children-heard/static/_content/8-sub3.png" style="top: 289px; left: 373px;"/>

      <img class="halfScale 8-3-img" src="/making-children-heard/static/_content/8-img-2.jpg" style="top: 540px; left: 144px;"/>
      <img class="halfScale 8-3-img" src="/making-children-heard/static/_content/8-img-3.jpg" style="top: 539px; left: 368px;"/>
      <img class="halfScaleC 8-3-btn" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg8-pop-1')" style="top: 741px; left:125px;"/>

      <img class="halfScaleC 8-3-btn" src="/making-children-heard/static/_content/btn-down.jpg" onclick="Publish.nextSection()" style="top: 485px; left: 939px;"/>

      <div id="pg8-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg8-pop1.jpg">
        <div class="abs pointer" onclick="Publish.openVideo('https://player.vimeo.com/video/256753961?autoplay=1&title=0&byline=0&portrait=0')" style="top:408px;left:989px;width:95px;height:95px;"></div>
        <div class="abs pointer" onclick="hideOverlay('pg8-pop-1')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg8sec3Anim = new TimelineMax();
        pg8sec3Anim.staggerFromTo(cOf("8-3-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .staggerFromTo(cOf("8-3-img"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, 0.4, "-=0.4")
        .fromTo(cOf("8-3-btn"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          cOf("8-3-btn")[0].className += " pointer pulse animatedpulse";
          cOf("8-3-btn")[1].className += " pointer pulse animatedpulse";
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg8sec3Anim.stop();
        cOf("8-3-btn")[0].className = "halfScaleC 8-3-btn";
        cOf("8-3-btn")[1].className = "halfScaleC 8-3-btn";
        hideOverlay('pg8-pop-1')
      }
      `,
      "searchText": "08/14  TERRE DES HOMMES  SUSTAINABLE DEVELOPMENT  SOUTH SUDAN “At night, we don't turn on the lights to study. You cannot attract attention” – Roger, 16 Sophia lives under siege with her children Anna and Roger in Yei, South Sudan. Terre des Hommes (Lausanne)’s urban farming project has provided seeds and tools to over 2,000 vulnerable families in Yei, allowing them to fight malnutrition by growing and  storing crops to eat and sell. Government security forces cut off the city from the surrounding area in 2016, making the tomatoes, aubergines, okra, cabbage and onions citizens can grow in Yei essential to their survival. ©TDH / Ollivier Girard  Click to read how our Indifesa campaign champions gender equality"
    },{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8-4.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 8-4-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 8-4-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScale 8-4-title" src="/making-children-heard/static/_content/8-kenya.png" style="top: 245px; left: 753px;"/>
      <img class="halfScale 8-4-title" src="/making-children-heard/static/_content/8-sub4.png" style="top: 289px; left: 432px;"/>

      <img class="halfScale 8-4-img" src="/making-children-heard/static/_content/8-img-4.jpg" style="top: 584px; left: 144px;"/>
      <img class="halfScale 8-4-img" src="/making-children-heard/static/_content/8-img-5.jpg" style="top: 584px; left: 365px;"/>
      <img class="halfScaleC 8-4-btn" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg8-pop-2')" style="top: 226px; left:125px;"/>
      <img class="halfScaleC 8-4-btn" src="/making-children-heard/static/_content/btn-plus.jpg" onclick="showOverlay('pg8-pop-3')" style="top: 399px; left: 125px;"/>

      <div class="addContentLink" style="top:460px;left:447px;width:141px;height:21px">
        <a href="http://wemacentre.org/" target="_blank"></a>
      </div>

      <div id="pg8-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg8-pop2.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg8-pop-2')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>
      <div id="pg8-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/pg8-pop3.jpg">
        <div class="abs pointer" onclick="hideOverlay('pg8-pop-3')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg8sec4Anim = new TimelineMax();
        pg8sec4Anim.staggerFromTo(cOf("8-4-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .staggerFromTo(cOf("8-4-img"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, 0.6, "-=0.4")
        .staggerFromTo(cOf("8-4-btn"), 0.8, {opacity:0}, {opacity:1}, 0.6, "-=0.4")
        .fromTo(cOf("8-4-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          addContentLinks();
          cOf("8-4-btn")[0].className += " pointer pulse animatedpulse";
          cOf("8-4-btn")[1].className += " pointer pulse animatedpulse";
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg8sec4Anim.stop();
        removeContentLinks();
        hideOverlay('pg8-pop-2');
        hideOverlay('pg8-pop-3');
        cOf("8-4-btn")[0].className = "halfScaleC 8-4-btn";
        cOf("8-4-btn")[1].className = "halfScaleC 8-4-btn";
      }
      `,
      "searchText": "08/14  SUSTAINABLE DEVELOPMENT  KENYA Click to read Combating child marriage in Mozambique  BACK  Click to read about advocating for girls' rights at the UN  “Thinking about my life in ten years, I imagine myself traveling and working in other countries of the world and encouraging and guiding other unfortunate children away from their struggles” – Mary, 17 Mary was forced to beg with her mother in the slums of Mombasa, Kenya. An employee from the Wema Centre, a local organisation sponsored by Terre des Hommes (Denmark), saw Mary begging in the street  and took her to the centre. The Wema Centre gave Mary the opportunity to learn and receive an education, empowering her to swap her life on the streets for a life in school.  ©TDH  NEXT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 9-1-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 9-1-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>
      
      <img class="halfScale 9-1-title" src="/making-children-heard/static/_content/9-title.png" style="top: 432px; left:629px;"/>
      <img class="halfScale 9-1-title" src="/making-children-heard/static/_content/9-sub.png" style="top: 520px; left: 428px;"/>
      <img class="halfScale 9-1-title" src="/making-children-heard/static/_content/9-destination.png" style="top: 644px; left: 644px;"/>

      <img class="halfScale 9-1-img" src="/making-children-heard/static/_content/9-img-1.jpg" style="top: 101px; left: 427px;"/>
      <img class="halfScale 9-1-img" src="/making-children-heard/static/_content/9-img-2.jpg" style="top: 699px; left: 149px;"/>
      <img id="9-read" class="halfScale pointer" src="/making-children-heard/static/_content/read-more.png" onclick="Publish.nextSection()" style="top: 860px; left:747px;"/>

      <div class="addContentLink" style="top:706px;left:661px;width:120px;height:21px">
        <a href="https://destination-unknown.org/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:737px;left:362px;width:100px;height:21px">
        <a href="https://destination-unknown.org/" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg9Anim = new TimelineMax();
        pg9Anim.staggerFromTo(cOf("9-1-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .staggerFromTo(cOf("9-1-img"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, 0.6, "-=1.0")
        .fromTo(idOf("9-read"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(cOf("9-1-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          addContentLinks();
          pg9Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});
          pg9Bounce.to(idOf("9-read"), 0.8, {y:-20, delay:0.8})
          .to(idOf("9-read"), 1, {y:0, ease:Bounce.easeOut}, "-=0")
        }}, "-=0.4")
      }
      

      function onPageLeave() {
        pg9Anim.stop();
        pg9Bounce.stop();
        removeContentLinks();
      }
      `,
      "searchText": "09/14  TERRE DES HOMMES  CAMPAIGNS  ©TDH / Andrea Frazzetta  CAMPAIGNING BACK  NEXT  Campaigning is built into the DNA of Terre des Hommes. We spearhead two campaigns which champion children’s rights – on children on the move and children influenced by mega sporting events  DESTINATION UNKNOWN Throughout 2017, the Destination Unknown campaign was active at global, regional and national levels, advocating for the human rights of children and  young people on the move to be upheld and respected. At the global level, Destination Unknown has been actively campaigning for two  READ MORE  ©TDH"
    },{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9-2.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 9-2-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 9-2-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScaleC 9-2-btn" onclick="showOverlay('9-gal')" src="/making-children-heard/static/_content/btn-gal.jpg" style="top: 742px; left: 125px;"/>

      <div class="addContentLink" style="top:552px;left:581px;width:200px;height:21px">
        <a href="http://www.childrenonthemove.org" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:583px;left:363px;width:345px;height:24px">
        <a href="http://www.childrenonthemove.org" target="_blank"></a>
      </div>

      <div id="9-gal" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="" style="top:0px;left:0px" src="/making-children-heard/static/_content/gal-bg.png">
        <img class="halfScale 9-gal-img-1" style="left:352px; top:133px;" src="/making-children-heard/static/_content/gal-1.png">
        <img class="halfScale 9-gal-img-2" style="left:352px; top:135px;opacity:0" src="/making-children-heard/static/_content/gal-2.png">
        <img class="halfScale 9-gal-img-3" style="left:353px; top:137px;opacity:0" src="/making-children-heard/static/_content/gal-3.png">
        <img class="halfScale 9-gal-img-4" style="left:353px; top:139px;opacity:0" src="/making-children-heard/static/_content/gal-4.png">
        <img class="halfScale 9-gal-img-5" style="left:353px; top:139px;opacity:0" src="/making-children-heard/static/_content/gal-5.png">
        <img class="halfScale 9-gal-img-6" style="left:353px; top:139px;opacity:0" src="/making-children-heard/static/_content/gal-6.png">
        <img class="halfScale 9-gal-img-7" style="left:353px; top:137px;opacity:0" src="/making-children-heard/static/_content/gal-7.png">
        <img class="halfScale 9-gal-img-8" style="left:353px; top:137px;opacity:0" src="/making-children-heard/static/_content/gal-8.png">

        <div class="abs pointer 9-gal-thumb" onclick="galleryImg(1);" style="top:811px;left:352px;width:84px;height:84px;"></div>
        <div class="abs pointer 9-gal-thumb" onclick="galleryImg(2);" style="top:811px;left:435px;width:84px;height:84px;"></div>
        <div class="abs pointer 9-gal-thumb" onclick="galleryImg(3);" style="top:811px;left:517px;width:84px;height:84px;"></div>
        <div class="abs pointer 9-gal-thumb" onclick="galleryImg(4);" style="top:811px;left:600px;width:84px;height:84px;"></div>
        <div class="abs pointer 9-gal-thumb" onclick="galleryImg(5);" style="top:811px;left:683px;width:84px;height:84px;"></div>
        <div class="abs pointer 9-gal-thumb" onclick="galleryImg(6);" style="top:811px;left:766px;width:84px;height:84px;"></div>
        <div class="abs pointer 9-gal-thumb" onclick="galleryImg(7);" style="top:811px;left:847px;width:84px;height:84px;"></div>
        <div class="abs pointer 9-gal-thumb" onclick="galleryImg(8);" style="top:811px;left:930px;width:84px;height:84px;"></div>

        <div class="abs pointer" onclick="hideOverlay('9-gal')" style="top:88px;left:1242px;width:38px;height:38px;"></div>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg9sec2Anim = new TimelineMax();
        pg9sec2Anim.fromTo(cOf("9-2-btn"), 0.8, {opacity:0}, {opacity:1}, 0.8)
        .fromTo(cOf("9-2-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){
          addContentLinks();
          cOf("9-2-btn")[0].className += " pointer pulse animatedpulse";
        }}, "-=0.4")
      }
      
      function galleryImg(index) {
        for (var i=1; i <= 9; i++) {
          if(i == index) {
            TweenMax.to(cOf("9-gal-img-"+i), 0.5, {opacity:1})
          } else {
            TweenMax.to(cOf("9-gal-img-"+i), 0.5, {opacity:0});
          }
        }
      }

      function onPageLeave() {
        pg9sec2Anim.stop();
        removeContentLinks();
        hideOverlay('9-gal')
        cOf("9-2-btn")[0].className = "halfScaleC 9-2-btn";
      }
      `,
      "searchText": "09/14  TERRE DES HOMMES  CAMPAIGNS  BACK  Click to view children's pictures of the hazards they face in South Africa  new international agreements, known as the UN Global Compacts on refugees and migration, to ensure they are childfocused and grounded on the rights of children. This is done with the aim of establishing a continuum of care, protection and support for all children on the move. Working with the Initiative for Child Rights in the Global Compacts – cochaired by Terre des Hommes and Save the Children – Destination Unknown led and participated in consultations and review meetings feeding into the Global Compacts, bringing our experience of working with children to the discussions. This collective work placed children’s rights on the agenda when governments began to negotiate the content of both Compacts.  Regional-level campaigning included Destination Unknown campaign partners in Southern Africa advocating for the rights of children on the move to be included in questions asked by the African Union committee responsible for rights and welfare. In seven global regions, Destination Unknown campaign members were active in advocacy, awareness-raising and mobilisation to strengthen protection of children in the move. For example, children and young people on the move in South Africa photographed the daily challenges they faced in Johannesburg. They then displayed their photographs in an exhibition within their local community – raising awareness on pollution, drug abuse, child abuse and other ©TDH social ills they are forced to live with.  NEXT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 10-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 10-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>

      <img class="halfScale 10-title" src="/making-children-heard/static/_content/10-title.png" style="top: 258px; left:623px;"/>
      <img class="halfScale 10-title" src="/making-children-heard/static/_content/10-sub.png" style="top: 338px; left: 553px;"/>

      <img class="halfScale 10-img" src="/making-children-heard/static/_content/10-img.jpg" style="top: 762px; left: 806px;"/>

      <div class="addContentLink" style="top:397px;left:405px;width:131px;height:24px">
        <a href="http://www.childrenwin.org/" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg10Anim = new TimelineMax();
        pg10Anim.staggerFromTo(cOf("10-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)
        .fromTo(cOf("10-img"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, "-=0.4")
        .fromTo(cOf("10-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: addContentLinks}, "-=0.4")
      }
      

      function onPageLeave() {
        pg10Anim.stop();
        removeContentLinks();
      }
      `,
      "searchText": "10/14  TERRE DES HOMMES  CAMPAIGNS  CHILDREN WIN Making mega sporting events respect child rights  BACK  The Children Win campaign, which is led by Terre des Hommes, aims to guarantee the rights of children are respected and promoted before, during and after mega sporting events. In 2017, the publication by UEFA of the bidding documents for the EURO 2024 football championship proved to be a watershed moment, as stipulations on human and child rights were included from the outset for the first time in a mega sporting event. Children Win also revisited Rio de Janeiro one year after the finale of the 2016 Olympic Games. The campaign interviewed children and parents from the favelas affected by construction work preparing for the Games.  Those interviewed highlighted how the ‘legacy’ of the games had not materialised for local residents, with facilities not being used and beneficial programmes curtailed. The Children Win campaign also influenced the human rights policy adopted by FIFA in 2017. Children Win fed into the final versions of these policies as part of the Sport and Rights Alliance, with a Terre des Hommes expert also sitting on FIFA’s human rights advisory board.  NEXT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
        <img class="halfScale 11-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
        <img class="halfScale 11-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>
        <img id="11-but-1" class="halfScale pointer" src="/making-children-heard/static/_content/11-but-1.jpg" style="top: 349px; left:169px;" onclick="showOverlay2('11-pop-1'); hideOverlay2('11-pop-2'); hideOverlay2('11-pop-3'); showButton('11-but-1'); hideButton('11-but-2'); hideButton('11-but-3');animatePop1();" />
        <img id="11-but-2" class="halfScale pointer hidden" src="/making-children-heard/static/_content/11-but-2.jpg" style="top: 521px; left:166px;" onclick="showOverlay2('11-pop-2'); hideOverlay2('11-pop-1'); hideOverlay2('11-pop-3'); showButton('11-but-2'); hideButton('11-but-1'); hideButton('11-but-3');animatePop2();" />
        <img id="11-but-3" class="halfScale pointer hidden" src="/making-children-heard/static/_content/11-but-3.jpg" style="top: 761px; left:163px;" onclick="showOverlay2('11-pop-3'); hideOverlay2('11-pop-1'); hideOverlay2('11-pop-2'); showButton('11-but-3'); hideButton('11-but-1'); hideButton('11-but-2');animatePop3();" />

        <div id="11-pop-1" class="">
          <img id="11-title-1" class="halfScale" src="/making-children-heard/static/_content/11-title-1.png" style="top: 197px; left:399px;"/>
          <img class="halfScale" src="/making-children-heard/static/_content/11-pop-1.jpg" style="top: 246px; left:365px;"/>
          <h1 class="abs dinpro 11-no-1 11-numbers" style="left:760px;top:248px; font-size: 3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 816, "append": ""}' ></h1>
          <h1 class="abs dinpro 11-no-1 11-numbers" style="left:1055px;top:361px; font-size: 3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 4009, "append": "", "comma": true}' ></h1>
          <h1 class="abs dinpro 11-no-1 11-numbers" style="left:1075px;top:594px; font-size: 3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 372, "append": ""}' ></h1>
          <h1 class="abs dinpro 11-no-1 11-numbers" style="left:647px;top:832px; font-size: 3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 183161256, "append": "", "preppend": "€", "comma": true}' ></h1>
          <h1 class="abs dinpro 11-no-1 11-numbers" style="left:408px;top:833px; font-size: 3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 5928, "append": "", "comma": true}' ></h1>
          <h1 class="abs dinpro 11-no-1 11-numbers" style="left:357px;top:596px; font-size: 3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 10125477, "append": "", "comma": true}' ></h1>
          <h1 class="abs dinpro 11-no-1 11-numbers" style="left:375px;top:358px; font-size: 3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 6562042, "append": "", "comma": true}' ></h1>
        </div>

        <div id="11-pop-2" class="hidden noclick">
        <img id="11-title-2" class="halfScale" src="/making-children-heard/static/_content/11-title-2.png" style="top: 197px; left:399px;"/>
          <img class="halfScale" src="/making-children-heard/static/_content/11-pop-2.jpg" style="top: 260px; left:365px;"/>
          <h1 class="abs dinpro 11-no-2 11-numbers" style="left:679px;top:294px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 34, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-2 11-numbers" style="left:820px;top:813px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 26, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-2 11-numbers" style="left:1098px;top:633px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 12, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-2 11-numbers" style="left:400px;top:420px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 12, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-2 11-numbers" style="left:1104px;top:493px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 16, "append": "%"}' ></h1>
        </div>
        <div id="11-pop-3" class="hidden noclick">
        <img id="11-title-3" class="halfScale" src="/making-children-heard/static/_content/11-title-3.png" style="top: 197px; left:399px;"/>
          <img class="halfScale" src="/making-children-heard/static/_content/11-pop-3.jpg" style="top: 266px; left:405px;"/>
          <h1 class="abs dinpro 11-no-3 11-numbers" style="left:440px;top:441px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 39, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-3 11-numbers" style="left:663px;top:441px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 28, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-3 11-numbers" style="left:878px;top:441px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 16, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-3 11-numbers" style="left:1111px;top:441px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 8, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-3 11-numbers" style="left:452px;top:777px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 3, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-3 11-numbers" style="left:672px;top:777px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 2, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-3 11-numbers" style="left:891px;top:777px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 1, "append": "%"}' ></h1>
          <h1 class="abs dinpro 11-no-3 11-numbers" style="left:1110px;top:777px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 3, "append": "%"}' ></h1>
        </div>

      `,
      "script": `
      function onPageEnter() {
        pg11Anim = new TimelineMax();
        pg11pop1Anim = new TimelineMax();
        pg11pop2Anim = new TimelineMax();
        pg11pop3Anim = new TimelineMax();
        pg11Anim.fromTo(cOf("11-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: animatePop1()}, 1)
      }
      
      function animatePop1() {
        pg11pop1Anim.fromTo(idOf("11-title-1"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.5)
        .fromTo(cOf("11-no-1")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-1")[0]);}},"-=0.2")
        .fromTo(cOf("11-no-1")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-1")[1]);}},"-=0.2")
        .fromTo(cOf("11-no-1")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-1")[2]);}},"-=0.2")
        .fromTo(cOf("11-no-1")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-1")[3]);}},"-=0.2")
        .fromTo(cOf("11-no-1")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-1")[4]);}},"-=0.2")
        .fromTo(cOf("11-no-1")[5], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-1")[5]);}},"-=0.2")
        .fromTo(cOf("11-no-1")[6], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-1")[6]);}},"-=0.2")
      }

      function animatePop2() {
        pg11pop2Anim.fromTo(idOf("11-title-2"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.5)
        .fromTo(cOf("11-no-2")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-2")[0]);}},"-=0.2")
        .fromTo(cOf("11-no-2")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-2")[1]);}},"-=0.2")
        .fromTo(cOf("11-no-2")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-2")[2]);}},"-=0.2")
        .fromTo(cOf("11-no-2")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-2")[3]);}},"-=0.2")
        .fromTo(cOf("11-no-2")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-2")[4]);}},"-=0.2")
      }

      function animatePop3() {
        pg11pop3Anim.fromTo(idOf("11-title-3"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.5)
        .fromTo(cOf("11-no-3")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-3")[0]);}},"-=0.2")
        .fromTo(cOf("11-no-3")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-3")[1]);}},"-=0.2")
        .fromTo(cOf("11-no-3")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-3")[2]);}},"-=0.2")
        .fromTo(cOf("11-no-3")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-3")[3]);}},"-=0.2")
        .fromTo(cOf("11-no-3")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-3")[4]);}},"-=0.2")
        .fromTo(cOf("11-no-3")[5], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-3")[5]);}},"-=0.2")
        .fromTo(cOf("11-no-3")[6], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-3")[6]);}},"-=0.2")
        .fromTo(cOf("11-no-3")[7], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("11-no-3")[7]);}},"-=0.2")
      }

      function onPageLeave() {
        resetNumbers('11-numbers');
        pg11Anim.stop();
        pg11pop1Anim.stop();
        pg11pop2Anim.stop();
        pg11pop3Anim.stop();
        showOverlay2('11-pop-1');
        showButton('11-but-1');
        hideOverlay2('11-pop-2');
        hideOverlay2('11-pop-3');
        hideButton('11-but-2');
        hideButton('11-but-3');
      }
      `,
      "searchText": "11/14 Statistics TERRE DES HOMMES TERRE DES HOMMES AT A GLANCE 816 Number of projects in 67 countries. 4,009 Number of employees in the field. 372 Number of employees at member organisation HQs. €183,161,256 Global income in EUR. 5,928 Number of volunteers. 10,125,477 Number of indirect beneficiaries. 6,562,042 Number of direct beneficiaries. PROJECT EXPENDITURE PER REGION 34% Middle East. 26% Africa. 16% Asia. 12% Latin America. 12% Europe. PROJECTS PER SECTOR OF ACTIVITY 39% Child Protection. 28% Humanitarian Aid. 16% Health and Nutrition. 8% Education and Professional Training. 3% Youth Empowerment. 2% Girls' and Women's Rights. 1% Community Based Development. 3% Other."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 12-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 12-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>
      <img id="12-title-1" class="halfScale" src="/making-children-heard/static/_content/12-title-1.png" style="top: 195px; left:417px;"/>
      <img id="12-but-1" class="halfScale pointer" src="/making-children-heard/static/_content/12-but-1.jpg" style="top: 346px; left:157px;" onclick="showOverlay2('12-pop-1'); hideOverlay2('12-pop-2'); showButton('12-but-1'); hideButton('12-but-2'); p12AnimatePop1();" />
      <img id="12-but-2" class="halfScale pointer hidden" src="/making-children-heard/static/_content/12-but-2.jpg" style="top: 560px; left:175px;" onclick="showOverlay2('12-pop-2'); hideOverlay2('12-pop-1'); showButton('12-but-2'); hideButton('12-but-1'); p12AnimatePop2();" />

      <div id="12-pop-1" class="">
        <img class="halfScale" src="/making-children-heard/static/_content/12-pop-1.jpg" style="top: 261px; left:397px;"/>
        <h1 class="abs dinpro 12-no-1 12-numbers" style="left:483px;top:706px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 37, "append": "%"}' ></h1>
        <h1 class="abs dinpro 12-no-1 12-numbers" style="left:483px;top:742px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 34, "append": "%"}' ></h1>
        <h1 class="abs dinpro 12-no-1 12-numbers" style="left:483px;top:779px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 12, "append": "%"}' ></h1>
        <h1 class="abs dinpro 12-no-1 12-numbers" style="left:483px;top:815px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 9, "append": "%"}' ></h1>
        <h1 class="abs dinpro 12-no-1 12-numbers" style="left:483px;top:852px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 6, "append": "%"}' ></h1>
        <h1 class="abs dinpro 12-no-1 12-numbers" style="left:483px;top:889px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 2, "append": "%"}' ></h1>
        <h1 class="abs dinpro 12-no-1 12-numbers" style="left:928px;top:706px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 82, "append": "%"}' ></h1>
        <h1 class="abs dinpro 12-no-1 12-numbers" style="left:928px;top:741px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 14, "append": "%"}' ></h1>
        <h1 class="abs dinpro 12-no-1 12-numbers" style="left:928px;top:808px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 4, "append": "%"}' ></h1>
      </div>

      <div id="12-pop-2" class="hidden noclick">
        <img class="halfScale" src="/making-children-heard/static/_content/12-pop-2.jpg" style="top: 264px; left:414px;"/>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:494px;width:28px;height:244px;background-color:#699390"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:529px;width:28px;height:315px;background-color:#a5d8ce"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:615px;width:28px;height:260px;background-color:#699390"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:649px;width:28px;height:344px;background-color:#a5d8ce"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:737px;width:28px;height:271px;background-color:#699390"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:770px;width:28px;height:363px;background-color:#a5d8ce"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:856px;width:28px;height:315px;background-color:#699390"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:890px;width:28px;height:344px;background-color:#a5d8ce"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:977px;width:28px;height:323px;background-color:#699390"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:1009px;width:28px;height:357px;background-color:#a5d8ce"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:1097px;width:28px;height:369px;background-color:#699390"></div>
        <div class="abs originBC noOverflow 12-graph" style="bottom:206px;left:1131px;width:28px;height:416px;background-color:#a5d8ce"></div>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg12Anim = new TimelineMax();
        pg12pop1Anim = new TimelineMax();
        pg12pop2Anim = new TimelineMax();
        pg12Anim.fromTo(idOf("12-title-1"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 1)
        .fromTo(cOf("12-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: p12AnimatePop1()}, "-=0.4")
      }
      
      function p12AnimatePop1() {
        pg12pop1Anim.fromTo(cOf("12-no-1")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no-1")[0]);}}, 0.5)
        .fromTo(cOf("12-no-1")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no-1")[1]);}},"-=0.2")
        .fromTo(cOf("12-no-1")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no-1")[2]);}},"-=0.2")
        .fromTo(cOf("12-no-1")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no-1")[3]);}},"-=0.2")
        .fromTo(cOf("12-no-1")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no-1")[4]);}},"-=0.2")
        .fromTo(cOf("12-no-1")[5], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no-1")[5]);}},"-=0.2")
        .fromTo(cOf("12-no-1")[6], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no-1")[6]);}},"-=0.2")
        .fromTo(cOf("12-no-1")[7], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no-1")[7]);}},"-=0.2")
        .fromTo(cOf("12-no-1")[8], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no-1")[8]);}},"-=0.2")
      }

      function p12AnimatePop2() {
        pg12pop2Anim.fromTo(cOf("12-graph")[0], 0.6, {height:0}, {height:244}, "-=0.4")
        .fromTo(cOf("12-graph")[1], 0.6, {height:0}, {height:315}, "-=0.4")
        .fromTo(cOf("12-graph")[2], 0.6, {height:0}, {height:260}, "-=0.4")
        .fromTo(cOf("12-graph")[3], 0.6, {height:0}, {height:344}, "-=0.4")
        .fromTo(cOf("12-graph")[4], 0.6, {height:0}, {height:271}, "-=0.4")
        .fromTo(cOf("12-graph")[5], 0.6, {height:0}, {height:363}, "-=0.4")
        .fromTo(cOf("12-graph")[6], 0.6, {height:0}, {height:315}, "-=0.4")
        .fromTo(cOf("12-graph")[7], 0.6, {height:0}, {height:344}, "-=0.4")
        .fromTo(cOf("12-graph")[8], 0.6, {height:0}, {height:323}, "-=0.4")
        .fromTo(cOf("12-graph")[9], 0.6, {height:0}, {height:357}, "-=0.4")
        .fromTo(cOf("12-graph")[10], 0.6, {height:0}, {height:369}, "-=0.4")
        .fromTo(cOf("12-graph")[11], 0.6, {height:0}, {height:416}, "-=0.4")

      }

      function onPageLeave() {
        resetNumbers('12-numbers');
        pg12Anim.stop();
        pg12pop1Anim.stop();
        pg12pop2Anim.stop();
        showOverlay2('12-pop-1');
        showButton('12-but-1');
        hideOverlay2('12-pop-2');
        hideButton('12-but-2');
      }
      `,
      "searchText": "12/14 Finances TERRE DES HOMMES TERRE DES HOMMES IN FIGURES Income by source/expenditure by sector. 37% General Public. 34% Government funds. 12% UN funds. 9% European Union funds. 6% Corporate sector. 2% Other. 82% Field projects. 14% Administration, fund raising and communication. 4% Advocacy and information. Global income 2012-2017"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `  
      <img class="halfScale 13-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>
      <img class="halfScale 13-arrow pointer" src="/making-children-heard/static/_content/btn-forward.png" onclick="Publish.nextPage()" style="top: 497px; left: 1259px;"/>
      <img id="13-title-1" class="halfScale" src="/making-children-heard/static/_content/13-title.png" style="top: 145px; left:368px;"/>
      <img id="13-but-1" class="halfScale pointer" src="/making-children-heard/static/_content/13-but-1.jpg" style="top: 278px; left:364px;" onclick="showOverlay2('13-pop-1'); hideOverlay2('13-pop-2'); hideOverlay2('13-pop-3'); hideOverlay2('13-pop-4'); showButton('13-but-1'); hideButton('13-but-2'); hideButton('13-but-3'); hideButton('13-but-4'); p13AnimatePop1();" />
      <img id="13-but-2" class="halfScale pointer hidden" src="/making-children-heard/static/_content/13-but-2.jpg" style="top: 434px; left:365px;" onclick="showOverlay2('13-pop-2'); hideOverlay2('13-pop-1'); hideOverlay2('13-pop-3'); hideOverlay2('13-pop-4'); showButton('13-but-2'); hideButton('13-but-1'); hideButton('13-but-3'); hideButton('13-but-4'); p13AnimatePop2();" />
      <img id="13-but-3" class="halfScale pointer hidden" src="/making-children-heard/static/_content/13-but-3.jpg" style="top: 617px; left:365px;" onclick="showOverlay2('13-pop-3'); hideOverlay2('13-pop-2'); hideOverlay2('13-pop-1'); hideOverlay2('13-pop-4'); showButton('13-but-3'); hideButton('13-but-2'); hideButton('13-but-1'); hideButton('13-but-4'); p13AnimatePop3();" />
      <img id="13-but-4" class="halfScale pointer hidden" src="/making-children-heard/static/_content/13-but-4.jpg" style="top: 780px; left:365px;" onclick="showOverlay2('13-pop-4'); hideOverlay2('13-pop-2'); hideOverlay2('13-pop-3'); hideOverlay2('13-pop-1'); showButton('13-but-4'); hideButton('13-but-2'); hideButton('13-but-3'); hideButton('13-but-1'); p13AnimatePop4();" />

      <div id="13-pop-1" class="">
        <img class="halfScale" src="/making-children-heard/static/_content/13-pop-1.jpg" style="top: 272px; left:587px;"/>
        <h1 class="abs dinpro 13-no-1 13-numbers" style="left:617px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 75.5, "append": "%", "decimals": 1}' ></h1>
        <h1 class="abs dinpro 13-no-1 13-numbers" style="left:617px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 10.5, "append": "%", "decimals": 1}' ></h1>
        <h1 class="abs dinpro 13-no-1 13-numbers" style="left:617px;top:891px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 8.5, "append": "%", "decimals": 1}' ></h1>
        <h1 class="abs dinpro 13-no-1 13-numbers" style="left:910px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 5.1, "append": "%", "decimals": 1}' ></h1>
        <h1 class="abs dinpro 13-no-1 13-numbers" style="left:910px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 0.4, "append": "%", "decimals": 1}' ></h1>
      </div>

      <div id="13-pop-2" class="hidden noclick">
        <img class="halfScale" src="/making-children-heard/static/_content/13-pop-2.jpg" style="top: 272px; left:587px;"/>
        <h1 class="abs dinpro 13-no-2 13-numbers" style="left:617px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 60, "append": "%"}' ></h1>
        <h1 class="abs dinpro 13-no-2 13-numbers" style="left:617px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 27, "append": "%"}' ></h1>
        <h1 class="abs dinpro 13-no-2 13-numbers" style="left:617px;top:891px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 13, "append": "%"}' ></h1>
      </div>

      <div id="13-pop-3" class="hidden noclick">
        <img class="halfScale" src="/making-children-heard/static/_content/13-pop-3.jpg" style="top: 272px; left:587px;"/>
        <h1 class="abs dinpro 13-no-3 13-numbers" style="left:617px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 48, "append": "%"}' ></h1>
        <h1 class="abs dinpro 13-no-3 13-numbers" style="left:617px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 27, "append": "%"}' ></h1>
        <h1 class="abs dinpro 13-no-3 13-numbers" style="left:617px;top:891px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 9, "append": "%"}' ></h1>
        <h1 class="abs dinpro 13-no-3 13-numbers" style="left:881px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 8, "append": "%"}' ></h1>
        <h1 class="abs dinpro 13-no-3 13-numbers" style="left:881px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 7, "append": "%"}' ></h1>
        <h1 class="abs dinpro 13-no-3 13-numbers" style="left:881px;top:891px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 1, "append": "%"}' ></h1>
      </div>

      <div id="13-pop-4" class="hidden noclick">
        <img class="halfScale" src="/making-children-heard/static/_content/13-pop-4.jpg" style="top: 272px; left:587px;"/>
        <h1 class="abs dinpro 13-no-4 13-numbers" style="left:617px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 58, "append": "%"}' ></h1>
        <h1 class="abs dinpro 13-no-4 13-numbers" style="left:617px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;"  data-number='{"to": 42, "append": "%"}' ></h1>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg13Anim = new TimelineMax();
        pg13pop1Anim = new TimelineMax();
        pg13pop2Anim = new TimelineMax();
        pg13pop3Anim = new TimelineMax();
        pg13pop4Anim = new TimelineMax();
        pg13Anim.fromTo(idOf("13-title-1"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 1)
        .fromTo(cOf("13-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: p13AnimatePop1()}, "-=0.4")
      }      

      function p13AnimatePop1() {
        pg13pop1Anim.fromTo(cOf("13-no-1")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-1")[0]);}}, 0.5)
        .fromTo(cOf("13-no-1")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-1")[1]);}},"-=0.2")
        .fromTo(cOf("13-no-1")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-1")[2]);}},"-=0.2")
        .fromTo(cOf("13-no-1")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-1")[3]);}},"-=0.2")
        .fromTo(cOf("13-no-1")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-1")[4]);}},"-=0.2")
      }

      function p13AnimatePop2() {
        pg13pop2Anim.fromTo(cOf("13-no-2")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-2")[0]);}}, 0.5)
        .fromTo(cOf("13-no-2")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-2")[1]);}},"-=0.2")
        .fromTo(cOf("13-no-2")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-2")[2]);}},"-=0.2")
      }

      function p13AnimatePop3() {
        pg13pop3Anim.fromTo(cOf("13-no-3")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-3")[0]);}}, 0.5)
        .fromTo(cOf("13-no-3")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-3")[1]);}},"-=0.2")
        .fromTo(cOf("13-no-3")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-3")[2]);}},"-=0.2")
        .fromTo(cOf("13-no-3")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-3")[3]);}},"-=0.2")
        .fromTo(cOf("13-no-3")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-3")[4]);}},"-=0.2")
        .fromTo(cOf("13-no-3")[5], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-3")[5]);}},"-=0.2")
      }

      function p13AnimatePop4() {
        pg13pop4Anim.fromTo(cOf("13-no-4")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-4")[0]);}}, 0.5)
        .fromTo(cOf("13-no-4")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no-4")[1]);}},"-=0.2")
      }

      function onPageLeave() {
        resetNumbers('13-numbers');
        pg13Anim.stop();
        pg13pop1Anim.stop();
        pg13pop2Anim.stop();
        pg13pop3Anim.stop();
        pg13pop4Anim.stop();
        showOverlay2('13-pop-1');
        showButton('13-but-1');
        hideOverlay2('13-pop-2');
        hideOverlay2('13-pop-3');
        hideOverlay2('13-pop-4');
        hideButton('13-but-2');
        hideButton('13-but-3');
        hideButton('13-but-4');
      }
      `,
      "searchText": "13/14 Secrtariat Finances TERRE DES HOMMES INTERNATIONAL SECRETARIAT FINANCE REPORT   ASSETS Percentage of total balance sheet (527,031.18 CHF). 75.5% Cash at Banks. 10.5% Accrued assets. 8.5% Accounts receivable. 5.1% Share development durable. 0.4% Cash. LIABILITIES AND OWN FUNDS Percentage of total balance sheet (527,031.18 CHF). 60% Own funds. 27% Project funds. 13% accrued expenses. INCOME Percentage of total income (1,585,093.43 CHF) 48% Membership fee. 27% Children Win grant. 9% Oak grant. 8% Specific projects. 7% Other resources. 1% Bank interest and gain on exchange. EXPENDITURE percentage of total expenditure (1,629,221.02 CHF) 58% Core costs. 42% Special activities"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 14-arrow pointer" src="/making-children-heard/static/_content/btn-back.png" onclick="Publish.previousPage()" style="top: 497px; left: 32px;"/>

      <img class="halfScale 14-title" src="/making-children-heard/static/_content/14-title.png" style="top: 194px; left:365px;"/>
      
      <img class="halfScale 14-text" src="/making-children-heard/static/_content/14-text-3.png" style="top: 368px; left: 144px;"/>
      <img class="halfScale 14-text" src="/making-children-heard/static/_content/14-text-2.png" style="top: 517px; left: 144px;"/>
      <img class="halfScale 14-text" src="/making-children-heard/static/_content/14-text-1.png" style="top: 689px; left: 144px;"/>
      
      <a href="http://www.terredeshommes.org/about/structure/" target="_blank">
        <img class="halfScaleC 14-img" src="/making-children-heard/static/_content/14-img-3.png" style="top: 211px; left: 99px;"/>
      </a>
      <a href="http://www.terredeshommes.org/members/" target="_blank">
        <img class="halfScaleC 14-img" src="/making-children-heard/static/_content/14-img-2.png" style="top: 360px; left: 99px;"/>
      </a>
      <a href="http://www.terredeshommes.org/contacts-2/" target="_blank">
        <img class="halfScaleC 14-img" src="/making-children-heard/static/_content/14-img-1.png" style="top: 533px; left: 99px;"/>
      </a>

      <div class="addContentLink" style="top:490px;left:424px;width:158px;height:24px">
        <a href="http://www.oakfnd.org/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:306px;left:934px;width:289px;height:24px">
        <a href="http://www.epim.info/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:338px;left:806px;width:262px;height:24px">
        <a href="http://www.epim.info/" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg14Anim = new TimelineMax();
        pg14Anim.fromTo(cOf("14-title"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)
        .staggerFromTo(cOf("14-img"), 0.8, {scale:0}, {scale:0.5, ease:Back.easeOut.config(1.7)}, 0.6, "-=0.4")
        .staggerFromTo(cOf("14-text"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0}, 0.6, "-=1.8")
        .fromTo(cOf("14-arrow"), 0.8, {opacity:0}, {opacity:1, onComplete: addContentLinks}, "-=0.4")
      }
      

      function onPageLeave() {
        pg14Anim.stop();
        removeContentLinks();
      }
      `,
      "searchText": "14/14  TERRE DES HOMMES  ACKNOWLEDGEMENTS  CLICK ICONS TO LINK THROUGH TO  International secretariat staff  BACK  Member organisations  International board  ACKNOWLEDGEMENTS Terre des Hommes wishes to express its profound gratitude to all donors and supporters for their ongoing and demonstrable commitment to raising standards for children, and making the changes necessary for a better world. Terre des Hommes is extremely grateful to the Oak Foundation for its long-standing partnership supporting the protection of children on the move and children affected by mega sporting events.  Terre des Hommes would also like to thank the European Programme for Integration and Migration, for its support and assistance in championing the rights of children on the move at European level. The names of all children mentioned in this report have been changed to protect their identity.  Managing Editor Delphine Moralis  Contributors Lysiane André, Laura Chello, Caroline Horne, Marc Joly, Eylah Kadjar-Hamouda  Production Elisa Buccolini, Paul Creeney Design Touchline  Special Thanks Jessica Fiorelli, Vanessa Nkembi"
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var thisPage = document.querySelector('.currentPage') 
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var thisPage = document.querySelector('.currentPage') 
        var contentLinks = [].slice.call(thisPage.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
      
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function showOverlay2(idx) {
        idOf(idx).className = 'visible'
      }

      function hideOverlay2(idx) {
        idOf(idx).className = 'hidden noclick'
      }

      function showButton(idx) {
        idOf(idx).className = 'halfScale pointer'
      }

      function hideButton(idx) {
        idOf(idx).className = 'halfScale pointer hidden'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend + comp+dp+append;
            }else{
              element.innerHTML = preppend + obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js